// For cache friendliness, we request in fixed-size batches, e.g. [0, 50), [50, 100), etc.
export const TEXT_BATCH_SIZE = 50;
/**
 * Calculate page batch size
 * @param currentPageIndex current page index
 */
export function calculatePageRange(currentPageIndex) {
    // First we calculate the bucket that this page falls into.
    const pageLowerBound = Math.floor(currentPageIndex / TEXT_BATCH_SIZE) * TEXT_BATCH_SIZE;
    const pageUpperBound = pageLowerBound + TEXT_BATCH_SIZE;
    return [pageLowerBound, pageUpperBound];
}
/*
 * Hook to debug what props are changed when a component re-renders. Uncomment when needed for debugging.
 */
//export const useDebugRerender = <T extends Record<string, unknown>>(props: T, name: string) => {
//  const oldPropsRef = React.useRef<T | null>(null);
//  const counterRef = React.useRef<number>(0);
//
//  const stringifyWithoutCycles = (json: unknown) => {
//    const seen: unknown[] = [];
//    const replacer = (_: unknown, val: unknown) => {
//      if (val != null && typeof val === 'object') {
//        if ('$$typeof' in val && val['$$typeof']) {
//          return '[React element]';
//        }
//        if (seen.indexOf(val) >= 0) {
//          return '[cyclic object]';
//        }
//        seen.push(val);
//      } else if (typeof val === 'function') {
//        return '[function]';
//      }
//      return val;
//    };
//    return JSON.stringify(json, replacer);
//  };
//
//  if (oldPropsRef.current) {
//    const oldProps = oldPropsRef.current;
//    const counter = counterRef.current;
//
//    const keys = Object.keys(props);
//    const oldKeys = Object.keys(oldProps);
//    const keysUnion = [...new Set([...keys, ...oldKeys])];
//    for (const key of keysUnion) {
//      const newProp = props[key];
//      const oldProp = oldProps[key];
//      if (newProp !== oldProp) {
//        // eslint-disable-next-line no-console
//        console.log(
//          `${name} rerender ${counter}: key: ${key} old: ${stringifyWithoutCycles(
//            oldProp
//          )}, new: ${stringifyWithoutCycles(newProp)}`
//        );
//      }
//    }
//  }
//  oldPropsRef.current = props;
//  counterRef.current++;
//};
export function getFilePresenceFileInfo(fileId, url) {
    if (url) {
        return {
            '.tag': 'shared_link_details',
            url: url,
        };
    }
    else {
        return {
            '.tag': 'file_identifier',
            file_identifier: fileId,
        };
    }
}
//# sourceMappingURL=functions.preenvesnextjs.map
